import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import PushService from 'cio/services/push';

export default class IndexRoute extends Route {
  @service push!: PushService;

  redirect() {
    let { platforms } = this.push;

    if (platforms.length === 0) {
      this.router.transitionTo('actions.push.ios');
    } else {
      let firstConfigured = platforms[0].key;
      this.router.transitionTo(`actions.push.${firstConfigured}`);
    }
  }
}
